import { render, staticRenderFns } from "./HealthEducationForm.vue?vue&type=template&id=460fcd3d"
import script from "./HealthEducationForm.vue?vue&type=script&lang=js"
export * from "./HealthEducationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports